import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';

export class AdAccountDto extends DataModel {
  static readonly TYPE_ID: string = 'bc255d298b5a400c8e2257b56b17661b';

  private constructor(
    public readonly uniqueId: string,
    public readonly name: string,
  ) {
    super();
  }

  get $typeId(): string {
    return AdAccountDto.TYPE_ID;
  }

  static create(args: {
    uniqueId: string,
    name: string,
  }): AdAccountDto {
    return new AdAccountDto(
        args.uniqueId,
        args.name,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): AdAccountDto {
    return AdAccountDto.create({
      uniqueId: MapUtils.getString(map, 'uniqueId'),
      name: MapUtils.getString(map, 'name'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'name': this.name,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    uniqueId = this.uniqueId,
    name = this.name,
  }: {
    uniqueId?: string,
    name?: string,
  } = {}): this {
    return AdAccountDto.create({
      uniqueId,
      name,
    }) as this;
  }

  isSame(other: AdAccountDto): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
      other.name === this.name;
  }
}

export class AdAccountDtoBuilder extends DataModelBuilder<AdAccountDto> {
  build(context: SerializationContext, map: SerializedData): AdAccountDto {
    return AdAccountDto.fromMap(context, map);
  }
}
